module.exports = __webpack_public_path__ + "static/media/dump.f112dadf.svg";